var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node',{attrs:{"config":_vm.config,"title":_vm.config.name,"is-root":true,"content":_vm.content,"placeholder":_vm.config.desc,"header-bgc":_vm.headerBgc,"header-icon":"el-icon-user-solid"},on:{"selected":function($event){return _vm.$emit('selected')},"insertNode":type => _vm.$emit('insertNode', type)}})
}
var staticRenderFns = []

export { render, staticRenderFns }